import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { AddressContainer } from '../../../../../common/address/containers/address.container';
import OneUserBasicInfoComponent from './one-user-basic-info.component';
import OneUserAccountInfoComponent from './one-user-account-info.componenet';
import OneUserProfileInfoComponent from './one-user-profile-info.component';
import OneUserAddressComponent from './one-user-primary-address-info.component';
import OneUserCommunityComponent from './one-user-community-info.component copy';
import OneUserProgramsComponent from './one-user-programs-info.component copy 2';

export const OneUserComponent = ({handleBasicFormChange, selectedAddress,handleInnerFormChange,id,tagNames,selectedOneUser,back,accounts,handleFormSubmit,selectedCustomer}: any) => {
  const tabItems=[
    {
        id:1,
        title:'ONE User Details',
        component:<OneUserBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOneUser={selectedOneUser}
        id={id}
        customerTags={tagNames}
        selectedCustomer={selectedCustomer}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Account Info',
      component:<OneUserAccountInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      selectedOneUser={selectedOneUser}
      accounts={accounts}
      handleBasicFormChange={handleBasicFormChange}
     />,
  isVisible:true,
  },
    {
        id:3,
        title:'User Profile',
        component:<OneUserProfileInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOneUser={selectedOneUser}
       />,
    isVisible:true,
    },
    {
      id: 4,
      title: 'Address',
      component: <OneUserAddressComponent
        onInnerFormChange={handleInnerFormChange}
        selectedAddress={selectedOneUser}
      />,
      isVisible: true,
    },

      {
      id: 5,
      title: 'Communities',
      component: <OneUserCommunityComponent
        onInnerFormChange={handleInnerFormChange}
         selectedOneUser={selectedOneUser}
      />,
      isVisible: true,
    },

    {
      id: 6,
      title: 'Programs',
      component: <OneUserProgramsComponent
        onInnerFormChange={handleInnerFormChange}
         selectedOneUser={selectedOneUser}
      />,
      isVisible: true,
    },
   
   

  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OneUserComponent;
